/*
  Billing: warning that history older than the cheaper plan keeps is deleted at night.
  Merged FIRST into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "History: data older than {days} days ({what}) will be deleted the night after the switch.": "История: данные старше {days} дней ({what}) будут удалены в ночь после перехода.",
  "clicks": "клики",
  "conversions": "конверсии",
  "leads": "лиды",
};

const es = {
  "History: data older than {days} days ({what}) will be deleted the night after the switch.": "Historial: los datos de más de {days} días ({what}) se eliminarán la noche siguiente al cambio.",
  "clicks": "clics",
  "conversions": "conversiones",
  "leads": "leads",
};

const pt = {
  "History: data older than {days} days ({what}) will be deleted the night after the switch.": "Histórico: os dados com mais de {days} dias ({what}) serão excluídos na noite seguinte à mudança.",
  "clicks": "cliques",
  "conversions": "conversões",
  "leads": "leads",
};

const de = {
  "History: data older than {days} days ({what}) will be deleted the night after the switch.": "Verlauf: Daten, die älter als {days} Tage sind ({what}), werden in der Nacht nach dem Wechsel gelöscht.",
  "clicks": "Klicks",
  "conversions": "Conversions",
  "leads": "Leads",
};

const fr = {
  "History: data older than {days} days ({what}) will be deleted the night after the switch.": "Historique : les données de plus de {days} jours ({what}) seront supprimées la nuit suivant le changement.",
  "clicks": "clics",
  "conversions": "conversions",
  "leads": "leads",
};

const it = {
  "History: data older than {days} days ({what}) will be deleted the night after the switch.": "Storico: i dati più vecchi di {days} giorni ({what}) verranno eliminati la notte dopo il cambio.",
  "clicks": "click",
  "conversions": "conversioni",
  "leads": "lead",
};

const pl = {
  "History: data older than {days} days ({what}) will be deleted the night after the switch.": "Historia: dane starsze niż {days} dni ({what}) zostaną usunięte w nocy po zmianie.",
  "clicks": "kliknięcia",
  "conversions": "konwersje",
  "leads": "leady",
};

const tr = {
  "History: data older than {days} days ({what}) will be deleted the night after the switch.": "Geçmiş: {days} günden eski veriler ({what}) geçişten sonraki gece silinecek.",
  "clicks": "tıklamalar",
  "conversions": "dönüşümler",
  "leads": "lead'ler",
};

const uk = {
  "History: data older than {days} days ({what}) will be deleted the night after the switch.": "Історія: дані, старші за {days} днів ({what}), буде видалено в ніч після переходу.",
  "clicks": "кліки",
  "conversions": "конверсії",
  "leads": "ліди",
};

const HISTORY_WARNING = { ru, es, pt, de, fr, it, pl, tr, uk };
export default HISTORY_WARNING;
